export enum OutputPortTypes{
    Three,
    Code,
    Text,
    Console
}  





// WEBPACK FOOTER //
// C:/Users/Akshata/Documents/GitHub/mobius-dev/src/app/base-classes/port/OutputPortTypes.ts